






import Vue from 'vue'

export default Vue.extend({
  name: 'SelectedEmployeeCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      const value = this.params.data.status
      if(value === 1 || value === 0) {
        return ''
      } else if (value === 2 || value === 3) {
        return 'clear'
      } else {
        return 'check'
      }
    },

    color (): string {
      // @ts-ignore
      const value = this.params.data.status
      if(value === 1  || value === 0) {
        return ''
      } else if (value === 2 || value === 3) {
        return 'red'
      } else {
        return 'green'
      }
    }
  }
})
